import React, { Component } from "react";
import crStyles from "../../../customerReservation/crStyles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import styles from "./CustomerOptOffline.module.scss";
import sharedStyles from "../OrderDetailsNewVersion.module.scss";
import FormControl from "@material-ui/core/FormControl";
import { withTranslation } from "react-i18next";
import CapitalizeText from "../../../../utils/CapitalizeText";
import UiDateUtils from "../../../../utils/UiDateUtils";
import CalendarDialog from "../calendarDialog/CalendarDialog";
import {
  OFFLINEDOCSIGN,
  PARTIALOFFLINE,
  SIGN_NOT_SELECTED,
  SIGN_OFFLINE,
} from "../../../../common/Constants";
import { HAS_VALUE } from "../../../../utils/EmpUtil";
import {
  StyledBasicExpansionPanel,
  StyledBasicExpansionPanelSummary,
} from "../../../../shared/ExpansionPanels/ExpansionPanel";
import HasPermissionTo from "../../../../common/HasPermissionTo";

const OrderInfo = ({
  actionDate: actionDate,
  userId: userId,
  dateAgreed: dateAgreed,
  recordedBy: recordedBy,
  dateSigned: dateSigned,
}) => {
  return (
    actionDate && (
      <div className={styles.detailsDiv}>
        <div className={styles.subTitleText}>
          {UiDateUtils.formattedDate(actionDate)}
        </div>
        <div>
          {userId && (
            <div>
              <span className={styles.recordedBy}>{recordedBy}</span>
              <span className={styles.dataText}>{CapitalizeText(userId)}</span>
            </div>
          )}
          {dateAgreed && (
            <div>
              <span className={styles.recordedBy}>{dateSigned}</span>
              <span className={styles.dataText}>
                {UiDateUtils.formattedDate(dateAgreed)}
              </span>
            </div>
          )}
        </div>
      </div>
    )
  );
};

class CustomerOptOffline extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandCustomerOptOffline: false,
    };

    this.canEditOptOffline =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "customerOptOffline:write"
      );
  }

  expandCustomerOptOffline() {
    this.setState({
      expandCustomerOptOffline: !this.state.expandCustomerOptOffline,
    });
  }

  saveCustomerOptOffline = (customerSignedDate) => {
    this.props.handleCustomerOptOffline(
      OFFLINEDOCSIGN,
      customerSignedDate,
      null
    );
  };

  savePricingUpdate = (customerSignedDate) => {
    this.props.handleCustomerOptOffline(
      PARTIALOFFLINE,
      customerSignedDate,
      null
    );
  };
  showPricingUpdate = (signAtStore, actionDate) => {
    return signAtStore ? actionDate : true;
  };

  render() {
    const showOrderFormCheckBox =
      this.props.offlineDocInfo.signStatus === SIGN_OFFLINE ||
      this.props.offlineDocInfo.signStatus === SIGN_NOT_SELECTED;
    return (
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "showPricingUpdate"
      ) &&
      showOrderFormCheckBox && (
        <StyledBasicExpansionPanel
          defaultExpanded={false}
          onChange={() => this.expandCustomerOptOffline()}
        >
          {this.props.isOrderCancelled && (
            <div className={this.props.overlay} />
          )}
          <StyledBasicExpansionPanelSummary style={crStyles.headerBarNeutral}>
            <div className={sharedStyles.headerBar}>
              <div
                data-testid="customerOptOfflineTitle"
                className={sharedStyles.boldHeader}
              >
                {showOrderFormCheckBox
                  ? this.props.t("CustomerOptOffline.customerOptAndPayTitle")
                  : this.props.t("CustomerOptOffline.customerOptTitle")}
              </div>
              <div>
                {this.state.expandCustomerOptOffline ? (
                  <ExpandLessIcon id="less" />
                ) : (
                  <ExpandMoreIcon id="more" />
                )}
              </div>
            </div>
            <br />
          </StyledBasicExpansionPanelSummary>
          <div className={styles.infoDiv}>
            <div className={styles.bottomBorder}></div>
            {showOrderFormCheckBox && (
              <FormControl>
                <CalendarDialog
                  {...this.props}
                  id="customerOrderForm"
                  saveCalendarDate={this.saveCustomerOptOffline}
                  todayDate={this.props.customerReservation.todayDate}
                  checkBoxText={this.props.t(
                    "CustomerOptOffline.customerHasSignedOrder"
                  )}
                  isDisabled={
                    !this.canEditOptOffline ||
                    HAS_VALUE(this.props.offlineDocInfo.dealerActionDate)
                  }
                  isChecked={HAS_VALUE(
                    this.props.offlineDocInfo.dealerActionDate
                  )}
                  hasMaxDate={true}
                  dialogTitle={this.props.t("CustomerOptOffline.dialogTitle")}
                  dialogDescription={this.props.t(
                    "CustomerOptOffline.dialogDescription"
                  )}
                />
                <OrderInfo
                  {...this.props}
                  actionDate={this.props.offlineDocInfo.dealerActionDate}
                  userId={this.props.offlineDocInfo.dealerUserId}
                  dateAgreed={this.props.offlineDocInfo.customerSignedDate}
                  recordedBy={this.props.t("CustomerOptOffline.recordedBy")}
                  dateSigned={this.props.t("CustomerOptOffline.dateSigned")}
                />
              </FormControl>
            )}
            <HasPermissionTo
              perform={["showPricingUpdate"]}
              permissions={this.props.user.permissions.rolePermissions}
              condition={this.showPricingUpdate(
                showOrderFormCheckBox,
                this.props.offlineDocInfo.dealerActionDate
              )}
              render={() => (
                <FormControl>
                  <CalendarDialog
                    {...this.props}
                    id="pricingUpdateForm"
                    saveCalendarDate={this.savePricingUpdate}
                    showTooltip={true}
                    todayDate={this.props.customerReservation.todayDate}
                    checkBoxText={this.props.t(
                      "CustomerOptOffline.pricingUpdate"
                    )}
                    isDisabled={
                      !this.canEditOptOffline ||
                      this.props.offlinePricingUpdate.partialOffline ||
                      this.props.isOrderCancelled
                    }
                    hasMaxDate={true}
                    dialogTitle={this.props.t(
                      "CustomerOptOffline.pricingDialogTitle"
                    )}
                    dialogDescription={this.props.t(
                      "CustomerOptOffline.pricingDialogDescription"
                    )}
                    isChecked={this.props.offlinePricingUpdate.partialOffline}
                  />
                  {this.props.offlinePricingUpdate.partialOffline && (
                    <OrderInfo
                      {...this.props}
                      actionDate={
                        this.props.offlinePricingUpdate.dealerActionDate
                      }
                      userId={
                        this.props.offlinePricingUpdate.dealerActionUserId
                      }
                      dateAgreed={
                        this.props.offlinePricingUpdate.dealerAcceptedDate
                      }
                      recordedBy={this.props.t("CustomerOptOffline.recordedBy")}
                      dateSigned={this.props.t("CustomerOptOffline.dateSigned")}
                    />
                  )}
                </FormControl>
              )}
            />
          </div>
        </StyledBasicExpansionPanel>
      )
    );
  }
}

export default withTranslation("emp")(CustomerOptOffline);
